import { mapState } from "vuex";

const profilesMixin = {
  data: function() {
    return {
      categories: null,
      categoriesSorted: null,
    };
  },
  computed: {
    ...mapState([
      "profiles",
      "mapProfiles",
      "isConnectedToIntranet",
      "favourites",
    ]),
  },
  watch: {
    profiles() {
      this.getCategoriesSorted();
      this.loaded = true;
    },
  },
  methods: {
    getCategoriesSorted: function() {
      this.getCategories();
      const ordered = {};
      if (
        this.categories.hasOwnProperty("Favoritter") &&
        Object.keys(this.categories["Favoritter"]).length > 0
      ) {
        ordered["Favoritter"] = this.categories["Favoritter"];
      }

      Object.keys(this.categories)
        .sort()
        .forEach((key) => {
          if (key !== "Favoritter") {
            ordered[key] = this.categories[key];
          }
        });

      if (this.useInDialog === false) {
        ordered["Mine kart"] = this.savedAndSharedMaps;
      }

      this.categoriesSorted = ordered;
    },
    showMapDuringSearch: function(categoryName, title) {
      if (categoryName === "Favoritter") {
        return false;
      }
      return title.toLowerCase().includes(this.searchValue.toLocaleLowerCase());
    },
    getCategories: function() {
      let categories = {};

      let favouriteCategory = {};

      for (let key in this.profiles) {
        let profile = this.profiles[key];
        if (!categories[profile.category]) {
          categories[profile.category] = {};
        }

        categories[profile.category][key] = profile;

        if (this.favourites.includes(key)) {
          favouriteCategory[key] = profile;
        }
      }

      if (Object.keys(favouriteCategory).length > 0) {
        categories["Favoritter"] = favouriteCategory;
      }

      if (!this.isConnectedToIntranet) {
        delete categories["Interne kart"];
      }

      this.categories = categories;
    },
  },
  mounted: function() {
    this.getCategoriesSorted();
  },
};

export default profilesMixin;
